import { HttpContext, httpResource } from '@angular/common/http';
import { Service, computed } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../../../core/http/http-context-tokens';

const RECURSO = `${environment.apiUrl}/sai/cartaservico/publico/rede-social`;

/** O ícone de quem não tem um válido: um link genérico. */
export const ICONE_REDE_SOCIAL_PADRAO = 'fa-solid fa-link';

/** O formato que o adm grava: o estilo do Font Awesome e o nome do ícone. */
const FORMATO_ICONE = /^fa-(brands|solid|regular) fa-[a-z0-9-]+$/;

/** O erro fica local: sem redes, o banner e o rodapé só não mostram os ícones. */
const ERRO_LOCAL = () => new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true);

/** Um item de `GET publico/rede-social`. */
export interface RedeSocialPublicaResponse {
  desRotuloRsc: string;
  desLinkRsc: string;
  desIconeRsc: string | null;
}

/** Uma rede social como o portal a desenha. */
export interface RedeSocialPortal {
  rotulo: string;
  link: string;
  /** Classe do Font Awesome, já conferida. */
  icone: string;
}

/**
 * A classe do ícone cadastrada no adm, se tiver o formato do Font Awesome; senão, o link
 * genérico. Um valor antigo (o nome Lucide `camera`, por exemplo) deixaria o botão vazio.
 */
export function iconeRedeSocial(classe: string | null | undefined): string {
  return classe && FORMATO_ICONE.test(classe) ? classe : ICONE_REDE_SOCIAL_PADRAO;
}

/**
 * As redes sociais do órgão, na ordem do cadastro, para o banner da homepage e o rodapé de
 * todas as páginas. É raiz: os dois lugares dividem uma requisição por carregamento da
 * página. O portal não envia o órgão: o back-end o resolve pelo host.
 */
@Service()
export class RedesSociaisPublicasService {
  private readonly redesApi = httpResource<ResponseApi<RedeSocialPublicaResponse[]>>(() => ({
    url: RECURSO,
    context: ERRO_LOCAL(),
  }));

  /**
   * As redes na ordem da API. Em falha, lista vazia.
   *
   * O `error()` é consultado antes do `value()`, que lança em estado de erro.
   */
  readonly redes = computed<readonly RedeSocialPortal[]>(() => {
    if (this.redesApi.error() !== undefined) return [];

    return (this.redesApi.value()?.data ?? []).map((rede) => ({
      rotulo: rede.desRotuloRsc,
      link: rede.desLinkRsc,
      icone: iconeRedeSocial(rede.desIconeRsc),
    }));
  });
}
